import { sdk as createProductSdk } from '@b2ag/module-product-sdk/dist/product.sdk.js'
import { buildCallerId } from '@b2ag/utils/src/caller-id'
import { accessTokenSource } from '@b2ag/axios-client'
import { useLogger } from '@b2ag/utils/src/useLogger'
import { getConfig } from './config'
import ProductService from './services/product.service'
import { i18n } from '@b2ag/locale'
import type { InvivoLocale } from '@invivodf/locale'
import type { Logger } from '@invivodf/logger-interface'

const logger = useLogger() as unknown as Logger
const callerId = buildCallerId()

const { productApiHost } = getConfig()

export const productApiClient = createProductSdk(`${productApiHost}`, {
  callerId,
  accessTokenSource,
  logger,
  localeSource: () => i18n.locale as InvivoLocale,
})

export const productService = new ProductService(productApiHost, productApiClient)
